var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 19C10.1761 19 10.4 18.7761 10.4 18.5V14.5588C10.4 14.2827 10.6239 14.0588 10.9 14.0588H13.1C13.3761 14.0588 13.6 14.2827 13.6 14.5588V18.5C13.6 18.7761 13.8239 19 14.1 19H15.9571C16.2333 19 16.4571 18.7761 16.4571 18.5V12.9118C16.4571 12.6356 16.681 12.4118 16.9571 12.4118H18.7246C19.1793 12.4118 19.398 11.854 19.0644 11.545L12.3398 5.31483C12.1481 5.1372 11.8519 5.1372 11.6602 5.31483L4.93557 11.545C4.60202 11.854 4.82068 12.4118 5.27538 12.4118H7.04286C7.319 12.4118 7.54286 12.6356 7.54286 12.9118V18.5C7.54286 18.7761 7.76671 19 8.04286 19H9.9Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ac2ea2b3927e393629e1cb6ef6a5a1b2.svg";
export { ForwardRef as ReactComponent };